import { ButtonColor, ButtonVariant } from "../Button";

export interface VariantStyles {
  base?: string;
  top?: string;
}

export const getVariantStyles = (
  variant: ButtonVariant,
  theme: ButtonColor
): VariantStyles =>
  ({
    primary: {
      base: `bg-orange-100 group-hover:bg-gold-500 ${
        variant === "3d" && "h-[48px]"
      }`,
      top: `text-orange-900 bg-orange-300 group-hover:bg-orange-400 group-active:bg-gold-600 group-disabled:bg-orange-300 ${
        variant === "outline"
          ? "text-orange-300/92 bg-orange-300/20 border border-orange-300/92 group-hover:bg-orange-300/25 group-disabled:bg-orange-300/20"
          : variant === "ghost"
          ? "text-white bg-transparent group-hover:bg-white/16 group-active:bg-white/20 group-disabled:bg-transparent"
          : variant === "text" &&
            "text-orange-900 bg-transparent group-hover:text-orange-400 group-hover:bg-transparent group-active:bg-transparent group-disabled:bg-transparent"
      }`,
    },
    secondary: {
      base: `bg-white/6 group-hover:brightness-125 group-disabled:bg-white/6 ${
        variant === "3d" && "h-[48px]"
      }`,
      top: `text-white bg-white/10 group-hover:bg-white/16 group-active:bg-white/20 group-disabled:bg-white/10 ${
        variant === "outline" &&
        "bg-transparent hover:bg-white-4 border border-white/92"
      }`,
    },
  }[theme] as VariantStyles);
